export default {
    title: 'Upload file',
    success: {
        upload: 'The file has been uploaded to ABS',
    },
};
